// extracted by mini-css-extract-plugin
module.exports = {"button-container":"styles_button-container__uuqfq","logo-container":"styles_logo-container__bOvFe","button-text":"styles_button-text__1v5AT"};